
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

import Moment from 'moment'

interface listOptions {
    pid: string;
    name: string;
    type?: string;
    code?: string;
    blhGoodsID?: string;
    amount: number | string;
    state: number;
    luckTime: number | string
}

@Options({
    data () {
        return {
            amountTotal: 0,
            list: null,
            isGeting: false
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
    },
    created () {
        this.getList()
    },
    mounted () {
        this.$common.track(this.aid, 'load', '红包记录页面')
        this.activityData && this.$common.pageLoaded()
        this.shareData.title && this.$common.onshare(this.shareData, this.aid)
    },
    methods: {
        ...mapMutations(['SET_YEARDATA', 'SET_HBDATA']),
        getList () {
            this.$request('/lottery/prize/list', {
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data: any) => {
                this.list = data.list || []
                this.formatList(this.list)
                this.$common.pageLoaded()
            }).catch(() => {
                this.list = []
            })
        },
        formatList (list: listOptions[]) {
            let amountTotal = 0
            this.list.forEach((val: listOptions, idx: number) => {
                const amount = val.amount as number
                if (val.state === 2) {
                    amountTotal += amount
                }
                val.amount = (amount / 100).toFixed(2)
                val.luckTime = Moment(val.luckTime).format('YYYY年MM月DD日 HH:mm')
                return val
            })
            this.amountTotal = (amountTotal / 100).toFixed(2)
        },
        open (item: listOptions) {
            this.$common.track(this.aid, 'click', '待拆')
            if (item.state == 1) {
                this.getData()
                this.SET_HBDATA(item)
            }
        },
        getData () {
            if (this.isGeting) return
            this.isGeting = true
            this.$request('/year-report-2020', {
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data: any) => {
                if (data && data.import_time) {
                    this.formatData(data)
                }
                this.isGeting = false
            }).catch((res: any) =>  {
                this.isGeting = false
            })
        },
        formatData (data: any) {
            let newData = JSON.parse(JSON.stringify(data))
            const times = ['import_time', 'first_news_view_date', 'first_discuss_date', 'first_share_date', 'first_live_view_date', 'first_dynamic_create_date', 'last_arrive_date', 'use_time_early', 'use_time_lately']
            for (let time of times) {
                newData[time] && (newData[time] = Moment(data[time]).format('YYYY-M-D-H-m').split('-'))
            }
            if (newData.channel_label){
                newData.channel_label = newData.channel_label.split(',')
            }
            this.SET_YEARDATA(newData)
            sessionStorage.setItem('YEARDATA', JSON.stringify(newData))
        },
    }
})
export default class List extends Vue {}
